var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ComputedLayout,{attrs:{"grid":_setup.grid,"items":_setup.items,"useAddons":true},scopedSlots:_vm._u([{key:"loading",fn:function(){return [_c(_setup.GlobalLoading)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }